/* BikeLink høydehjelper (r12)
 * Kunden skriver inn høyden (cm). Hvert produktkort har data-bl-fit med MMRs høydeintervall per størrelse
 * (fra metafelt bikelink.storrelsesguide, kun størrelser produktet faktisk selges i). Skriptet markerer
 * passende størrelse på kortet og kan skjule sykler uten passende størrelse i lister med høydefeltet.
 * Høyden lagres i localStorage («bl_height_cm») og gjelder på hele nettstedet.
 */
(() => {
  if (window.BLFit) return;
  const KEY = 'bl_height_cm';
  const KEY_ONLY = 'bl_height_only';
  const MIN = 140, MAX = 215;

  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { v == null ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch (e) {} }
  };
  const getHeight = () => {
    const v = parseInt(store.get(KEY), 10);
    return v >= MIN && v <= MAX ? v : null;
  };
  const onlyFit = () => store.get(KEY_ONLY) !== '0';

  const parse = (el) => {
    if (el._blFit !== undefined) return el._blFit;
    let d = null;
    try { d = JSON.parse(el.getAttribute('data-bl-fit') || 'null'); } catch (e) { d = null; }
    el._blFit = Array.isArray(d) && d.length ? d : null;
    return el._blFit;
  };
  const fits = (r, h) => (r.f == null || h >= r.f) && (r.t == null || h <= r.t);
  const evaluate = (data, h) => {
    const m = data.filter((r) => fits(r, h));
    const inStock = m.filter((r) => r.a);
    return { sizes: m.map((r) => r.s), inStock: inStock.map((r) => r.s), state: !m.length ? 'nomatch' : (inStock.length ? 'match' : 'soldout') };
  };
  const joinSizes = (a) => a.join(' / ');
  const range = (r) => (r.f != null && r.t != null) ? `${r.f}–${r.t} cm` : (r.f != null ? `fra ${r.f} cm` : `opptil ${r.t} cm`);

  /* ---------- produktkort ---------- */
  function badgeFor(card, res, h) {
    let b = card.querySelector(':scope .bl-fit-badge');
    if (!res) { if (b) b.remove(); return; }
    if (!b) {
      b = document.createElement('p');
      b.className = 'bl-fit-badge text-xs';
      b.style.justifySelf = 'start';
      b.style.alignSelf = 'start';
      b.style.marginLeft = '0';
      b.style.marginRight = '0';
      const info = card.querySelector('.product-card__info');
      const stack = info && (info.querySelector('.v-stack .v-stack') || info.querySelector('.v-stack'));
      const anchor = stack && (stack.querySelector('.product-card__options') || stack.querySelector('.price-list') || stack.querySelector('.product-title'));
      if (anchor) anchor.after(b);
      else if (stack) stack.appendChild(b);
      else if (info) info.appendChild(b);
      else return;
    }
    b.dataset.state = res.state;
    if (res.state === 'match') {
      const s = res.inStock.length ? res.inStock : res.sizes;
      b.innerHTML = `<span class="bl-fit-badge__dot" aria-hidden="true"></span>Din størrelse: <strong>${joinSizes(s)}</strong>`;
      if (res.sizes.length > 1) b.title = `Du er mellom to størrelser (${h} cm)`;
    } else if (res.state === 'soldout') {
      b.innerHTML = `<span class="bl-fit-badge__dot" aria-hidden="true"></span>Din størrelse <strong>${joinSizes(res.sizes)}</strong> er utsolgt`;
    } else {
      b.innerHTML = `<span class="bl-fit-badge__dot" aria-hidden="true"></span>Ingen størrelse for ${h} cm`;
    }
  }

  function applyCards(h) {
    const scopes = new Map();
    document.querySelectorAll('product-card[data-bl-fit]').forEach((card) => {
      const data = parse(card);
      const res = h && data ? evaluate(data, h) : null;
      if (res) card.setAttribute('data-bl-fit-state', res.state); else card.removeAttribute('data-bl-fit-state');
      badgeFor(card, res, h);
      const sec = card.closest('.shopify-section');
      if (sec && sec.querySelector('bl-height-fit[mode="grid"]')) {
        if (!scopes.has(sec)) scopes.set(sec, { total: 0, known: 0, match: 0, soldout: 0 });
        const c = scopes.get(sec);
        c.total++;
        if (res) { c.known++; if (res.state === 'match') c.match++; if (res.state === 'soldout') c.soldout++; }
      }
    });
    return scopes;
  }

  /* ---------- høydefeltet ---------- */
  class BLHeightFit extends HTMLElement {
    connectedCallback() {
      if (this._init) { this.sync(); return; }
      this._init = true;
      this.form = this.querySelector('.bl-fit__form');
      this.input = this.querySelector('.bl-fit__input');
      this.msg = this.querySelector('.bl-fit__msg');
      this.result = this.querySelector('.bl-fit__result');
      this.summary = this.querySelector('.bl-fit__summary');
      this.only = this.querySelector('.bl-fit__only');
      this.form.addEventListener('submit', (e) => { e.preventDefault(); e.stopPropagation(); this.commit(true); });
      this.input.addEventListener('input', () => {
        clearTimeout(this._t);
        const v = this.input.value.trim();
        if (v.length >= 3) this._t = setTimeout(() => this.commit(false), 450);
        else if (!v) this.message('');
      });
      this.input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); this.commit(true); } });
      if (this.only) this.only.addEventListener('change', () => { store.set(KEY_ONLY, this.only.checked ? '1' : '0'); BLFit.update(); });
      this.querySelector('.bl-fit__clear').addEventListener('click', () => { this.input.value = ''; BLFit.setHeight(null); this.input.focus(); });
      this.sync();
    }
    message(t) { this.msg.textContent = t; this.msg.hidden = !t; }
    commit(strict) {
      const raw = this.input.value.trim();
      if (!raw) { BLFit.setHeight(null); return; }
      const v = Math.round(parseFloat(raw.replace(',', '.')));
      if (!(v >= MIN && v <= MAX)) { if (strict || raw.length >= 3) this.message(`Skriv en høyde mellom ${MIN} og ${MAX} cm.`); return; }
      this.message('');
      if (v !== getHeight()) BLFit.setHeight(v); else BLFit.update();
      if (strict && this.input.blur && window.matchMedia('(max-width: 699px)').matches) this.input.blur();
    }
    sync() {
      const h = getHeight();
      if (document.activeElement !== this.input) this.input.value = h || '';
      if (this.only) this.only.checked = onlyFit();
      this.result.hidden = !h;
      this.classList.toggle('is-active', !!h);
      if (this.getAttribute('mode') === 'product') this.renderProduct(h);
    }
    renderProduct(h) {
      const data = parse(this);
      if (!h || !data) { this.summary.textContent = ''; this.highlightChips([]); return; }
      const res = evaluate(data, h);
      const rows = data.filter((r) => res.sizes.includes(r.s));
      if (res.state === 'nomatch') {
        this.summary.innerHTML = `Denne modellen finnes ikke i en størrelse for <strong>${h} cm</strong>. <a class="link" href="/pages/contact">Spør oss</a> om et alternativ.`;
      } else {
        const between = res.sizes.length > 1 ? ' Du er mellom to størrelser – prøv begge eller spør oss.' : '';
        const sold = res.state === 'soldout' ? ' Den er dessverre utsolgt akkurat nå.' : (res.inStock.length < res.sizes.length ? ` (${joinSizes(res.sizes.filter((s) => !res.inStock.includes(s)))} er utsolgt)` : '');
        this.summary.innerHTML = `For <strong>${h} cm</strong> anbefaler MMR <strong>${joinSizes(res.sizes)}</strong> <span class="text-subdued">(${rows.map((r) => r.s + ' ' + range(r)).join(', ')})</span>.${sold}${between}`;
        const pick = (res.inStock.length ? res.inStock : res.sizes);
        const inputs = this.sizeInputs();
        const btns = inputs.some((i) => i.checked && pick.includes(i.size)) ? [] : pick.filter((s) => inputs.some((i) => i.size === s));
        if (btns.length) {
          const wrap = document.createElement('span');
          wrap.className = 'bl-fit__pick';
          btns.forEach((s) => {
            const b = document.createElement('button');
            b.type = 'button'; b.className = 'bl-fit__pick-btn text-xs'; b.textContent = `Velg ${s}`;
            b.addEventListener('click', () => { const i = this.sizeInputs().find((x) => x.size === s); if (i) { i.input.click(); BLFit.update(); } });
            wrap.appendChild(b);
          });
          this.summary.append(' ', wrap);
        }
      }
      this.highlightChips(res.sizes);
    }
    sizeInputs() {
      const out = [];
      document.querySelectorAll('fieldset.variant-picker__option').forEach((fs) => {
        const legend = fs.querySelector('legend');
        if (!legend || !/st(ø|o)rrelse|size/i.test(legend.textContent)) return;
        fs.querySelectorAll('input[type="radio"]').forEach((i) => {
          const lbl = i.closest('label') || (i.id && fs.querySelector(`label[for="${CSS.escape(i.id)}"]`));
          if (!lbl) return;
          const txt = ((lbl.querySelector('span') || lbl).textContent || '').trim();
          if (txt && !out.some((o) => o.size === txt)) out.push({ input: i, label: lbl, size: txt, checked: i.checked });
        });
      });
      return out;
    }
    highlightChips(sizes) {
      const root = this.closest('product-info, .product-info, .product') || document;
      root.querySelectorAll('.bikelink-size-hint__chip, [data-bl-size-chip]').forEach((c) => {
        const s = (c.getAttribute('data-bl-size-chip') || (c.querySelector('strong') || {}).textContent || '').trim();
        c.classList.toggle('is-fit', sizes.includes(s));
      });
      // Marker størrelsesknappene i variantvelgeren (kun visuelt, velger ingenting automatisk)
      this.sizeInputs().forEach((o) => o.label.classList.toggle('bl-fit-option', sizes.includes(o.size)));
    }
    setSummary(c) {
      if (!this.summary || this.getAttribute('mode') !== 'grid') return;
      const h = getHeight();
      if (!h || !c) { this.summary.textContent = ''; return; }
      const page = this.hasAttribute('paginated') ? ' på denne siden' : '';
      if (c.known === 0) { this.summary.textContent = `Ingen størrelsesdata for syklene${page}.`; return; }
      if (c.match === 0) {
        this.summary.innerHTML = `Ingen sykler${page} er på lager i en MMR-størrelse for <strong>${h} cm</strong>.${c.soldout ? ` ${c.soldout} finnes i din størrelse, men er utsolgt.` : ''} <a class="link" href="/pages/contact">Spør oss</a>.`;
        return;
      }
      this.summary.innerHTML = `<strong>${c.match}</strong> av ${c.total} sykler${page} finnes i din størrelse for <strong>${h} cm</strong>.${c.soldout ? ` ${c.soldout} til passer, men er utsolgt.` : ''}`;
    }
  }

  /* ---------- felles oppdatering ---------- */
  let raf = 0;
  const BLFit = window.BLFit = {
    getHeight,
    setHeight(h) {
      store.set(KEY, h == null ? null : String(h));
      document.dispatchEvent(new CustomEvent('bikelink:height-change', { detail: { height: h } }));
      this.update();
    },
    update() { cancelAnimationFrame(raf); raf = requestAnimationFrame(run); }
  };

  function run() {
    const h = getHeight();
    const scopes = applyCards(h);
    document.querySelectorAll('bl-height-fit').forEach((el) => {
      if (el.sync) el.sync();
      const sec = el.closest('.shopify-section');
      let c = sec && scopes.get(sec);
      if (!c && el.getAttribute('mode') === 'grid') c = scopes.values().next().value; // filterskuffen kan være flyttet ut av seksjonen
      if (el.setSummary) el.setSummary(c);
      if (sec && el.getAttribute('mode') === 'grid') {
        const active = !!h && !!c && c.match > 0 && onlyFit();
        sec.toggleAttribute('data-bl-fit-only', active);
        sec.toggleAttribute('data-bl-fit-active', !!h);
      }
    });
  }

  if (!customElements.get('bl-height-fit')) customElements.define('bl-height-fit', BLHeightFit);

  // Filter/sortering/paginering bytter ut HTML-en via AJAX – kjør på nytt når nye kort dukker opp
  const mo = new MutationObserver((list) => {
    for (const m of list) for (const n of m.addedNodes) {
      if (n.nodeType === 1 && (n.matches('product-card, bl-height-fit, .variant-picker__option') || n.querySelector('product-card, bl-height-fit, .variant-picker__option'))) { BLFit.update(); return; }
    }
  });
  const start = () => { mo.observe(document.body, { childList: true, subtree: true }); BLFit.update(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
  window.addEventListener('storage', (e) => { if (e.key === KEY || e.key === KEY_ONLY) BLFit.update(); });
  window.addEventListener('pageshow', () => BLFit.update());
})();
